window.addEventListener("DOMContentLoaded", () => {
  const regionButton = document.querySelectorAll(".nav-region__btn")
  const regionContainer = document.querySelector(".nav-region")
  const regionList = document.querySelector(".nav-region__wrapper")
  const searchInput = document.querySelector(".nav-region__input")
  const listItems = document.querySelectorAll('.region__item a')
  const closeButton = regionList.querySelector(".nav-region__close")

  regionButton.forEach(e => e.addEventListener("click", (e) => {
    e.preventDefault()
    if (!regionContainer.classList.contains("overlay-visible")) {
      openRegions()
    } else {
      closeRegions()
    }
  }))

  const filterList = (e) => {
    listItems.forEach((item) => {
      if (item.textContent.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())) {
        item.parentNode.style.display = "block"
      } else {
        item.parentNode.style.display = "none"
      }
    })
  }

  const openRegions = () => {
    regionList.classList.add("overlay-visible", "active")
    closeButton.addEventListener('click', closeRegions)
    searchInput.addEventListener("input", filterList)
  }

  const closeRegions = () => {
    regionList.classList.remove("overlay-visible", "active")
    closeButton.removeEventListener('click', closeRegions)
  }
})

